import { render, staticRenderFns } from "./gallery-component.vue?vue&type=template&id=2c35e690&scoped=true&"
import script from "./gallery-component.vue?vue&type=script&lang=ts&"
export * from "./gallery-component.vue?vue&type=script&lang=ts&"
import style0 from "./gallery-component.vue?vue&type=style&index=0&id=2c35e690&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c35e690",
  null
  
)

export default component.exports